import { render } from "./AsociaDesasociaRol.vue?vue&type=template&id=16bba2fd&scoped=true"
import script from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"
export * from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"

import "./AsociaDesasociaRol.vue?vue&type=style&index=0&id=16bba2fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bba2fd"]])

export default __exports__